import { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function useFilterParam(
    tableName: string,
    filterName: string,
    initialState: string = '',
) {
    const history = useHistory();
    const location = useLocation();
    const params = useMemo(() => {
        return new URLSearchParams(location.search);
    }, [location.search]);
    const paramKey = tableName ? `${tableName}-${filterName}` : filterName;

    const [state, setState] = useState(
        () => params.get(paramKey) || initialState,
    );

    const setParamState = useCallback(() => {
        const previousParams = new URLSearchParams(location.search);
        const paramsMap: { [key: string]: string } = {};
        previousParams.forEach((value, key) => (paramsMap[key] = value));
        if (state) {
            paramsMap[paramKey] = state;
        } else {
            delete paramsMap[paramKey];
        }
        // always set search page in url back to page 1 when a new search is started

        if (
            paramsMap[paramKey] !== params.get(paramKey) &&
            paramsMap['page_number'] &&
            paramKey !== 'page_number'
        ) {
            paramsMap['page_number'] = '1';
        }

        // check if the current search  matches the last known url search term and make sure to only display page numbers in url if the table supports pagination
        history.replace({
            pathname: location.pathname,
            search: new URLSearchParams(paramsMap).toString(),
            state: location.state, // take previous state forward, pathname is same so we can do this
        });
    }, [
        location.search,
        location.pathname,
        location.state,
        state,
        paramKey,
        params,
        history,
    ]);

    useEffect(() => {
        setParamState();
    }, [state, setParamState]);

    return [state, setState] as const;
}
